/**
 * Histopathology Home – Histopathology Report (dummy screen).
 */
import React from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

export default function HistopathologyReport() {
  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h6" color="text.secondary">Histopathology – Histopathology Report</Typography>
    </Box>
  );
}
